import Box from '@mui/material/Box'
import CssBaseline from '@mui/material/CssBaseline'
import { FC, ReactNode, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { SocketProvider } from '../realtime'
import { useAppSelector } from '../redux-store/hooks'
import Header from './Header'
import SideBar from './SideBar'

interface LayoutProps {
  children?: ReactNode
  isLoaderActive: boolean
  toggleTheme: () => void
}

const Layout: FC<LayoutProps> = ({ children, isLoaderActive, toggleTheme }) => {
  const [open, setOpen] = useState(true)
  const HEADER_HEIGHT = useAppSelector((state) => state.ui.HEADER_HEIGHT)

  const handleDrawerOpen = () => {
    setOpen(true)
  }

  const handleDrawerClose = () => {
    setOpen(false)
  }

  return (
    <SocketProvider>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <Header
          open={open}
          handleDrawerOpen={handleDrawerOpen}
          isLoaderActive={isLoaderActive}
        />
        <SideBar
          open={open}
          handleDrawerClose={handleDrawerClose}
          toggleTheme={toggleTheme}
        />
        {/* <DrawerHeader /> */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            overflow: 'auto',
            height: `calc(100vh - ${HEADER_HEIGHT}px)`,
            marginTop: `${HEADER_HEIGHT}px`,
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </SocketProvider>
  )
}

export { Layout }
